import { createCommand } from '@atlassian/rovo-content-bridge-api';

/**
 * Properties for the result of the read content command.
 */

/**
 * A command sent by a bridge API client to return the current content of a content type. It will have a different result type for each content type.
 *
 * @summary {@link CommandProperties.senderId} is requesting {@link CommandProperties.receiverId} to return the current content of a content type.
 */
export var ReadContentCommand = createCommand('read-content-command');